import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Icon from 'ol/style/Icon';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import proj4 from 'proj4';
import MapElement from './MapElement';
import { Circle, Fill, Stroke, Style } from 'ol/style.js';

import Select from 'ol/interaction/Select';
import { always, singleClick } from 'ol/events/condition';

export default class MapDevices extends MapElement {
    constructor(map, id, mapElementSettings, parent) {
        super(map, id, mapElementSettings, parent);
        this.devices = [];
        this.machineIconSource = null;

        this.machineStyle = (feature, resolution) => {
            if (feature.get('online'))
                return this.machineIconOnlineStyle;
            return this.machineIconOfflineStyle;
        };

        this.machineIconOnlineStyle = new Style({
            image: new Icon({
                anchor: [0.5, 1],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: '../../images/onlineMachine.png',
            }),
        });
        this.machineIconOfflineStyle = new Style({
            image: new Icon({
                anchor: [0.5, 1],
                anchorXUnits: 'fraction',
                anchorYUnits: 'fraction',
                src: '../../images/offlineMachine.png',
            }),
        });

        this.drawLayer();
    }

    initializeSelect() {
        super.initializeSelect();
        this.selectInteraction.style_ = this.machineStyle;
    }

    clearSelectedDevices() {
        this.selectInteraction.getFeatures().clear();
    }

    drawLayer() {
        this.machineIconSource = new VectorSource();
        this.layer = new VectorLayer({
            source: this.machineIconSource,
            style: this.machineStyle,
            zIndex: 200
        });

        this.mapModel.map.addLayer(this.layer);

        if (!this.mapElementSettings.defaultOn) {
            this.hide();
        }
    }

    getDevices() {
        return this.devices;
    }

    addDevice(id, name, data, x, y, status, projection = 'EPSG:4326') {
        if (!data.designator?.startsWith("*EndOfLife*")) {
            var source = new proj4.Proj(projection);
            var dest = new proj4.Proj(this.mapModel.projection);

            var position = proj4.transform(source, dest, [x, y]);

            var machineIconFeature = new Feature({
                deviceId: id,
                deviceData: data,
                name: name,
                geometry: new Point([position.x, position.y]),
                online: status
            });


            this.devices.push([id, name, x, y, projection]);
            this.machineIconSource.addFeature(machineIconFeature);
        }
    }

    clear() {
        this.machineIconSource.clear();
    }

    //doesnt work?
    getExtendForFeature(accountId) {
        var selectedFeature;
        this.layer.getSource().getFeatures().forEach(feature => {
            if (accountId == feature.get('deviceData').accountId) {
                selectedFeature = feature;
            }
        });
        return selectedFeature.getGeometry().getExtent();
    }
}